import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

/**
 * Shows the date range spanned by the loaded voucher data.
 */
export default function DataPeriodCard({ dateRange }) {
  if (!dateRange) return null;
  return (
    <Card className="border border-slate-200 shadow-none mb-8">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold text-slate-700">Data Period</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-slate-600">
          From:{" "}
          <span className="font-mono font-medium">
            {dateRange.min_date?.split("T")[0] || "N/A"}
          </span>{" "}
          To:{" "}
          <span className="font-mono font-medium">
            {dateRange.max_date?.split("T")[0] || "N/A"}
          </span>
        </p>
      </CardContent>
    </Card>
  );
}
